import React from "react";

interface LogoTypeSmartProps {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
  onClick?: () => void;
}

const LogoTypeSmart: React.FC<LogoTypeSmartProps> = ({ 
  className = "",
  fill = "currentColor",
  width = 137,
  height = 18,
  onClick
}) => {
    const handleClick = () => {
      if (onClick) {
        onClick();
      } else {
        // Default behavior: open SmartX website
        window.open('https://smartx.ir/', '_blank');
      }
    };

    return (
      <div 
        className={`cursor-pointer inline-block ${className}`}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick();
          }
        }}
      >
        <svg width={width} height={height} viewBox="0 0 137 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.3106 7.65373H5.16435C4.83122 7.668 4.49864 7.6147 4.18665 7.49705C3.87466 7.37941 3.5897 7.19985 3.34894 6.96917C3.10817 6.7385 2.91658 6.46149 2.78569 6.15481C2.6548 5.84814 2.58733 5.51815 2.58733 5.18472C2.58733 4.85128 2.6548 4.52129 2.78569 4.21462C2.91658 3.90795 3.10817 3.63094 3.34894 3.40027C3.5897 3.16959 3.87466 2.99002 4.18665 2.87237C4.49864 2.75472 4.83122 2.70143 5.16435 2.71569H8.75811L11.4738 0H5.16435C3.79468 0 2.4811 0.544102 1.5126 1.5126C0.544095 2.48111 0 3.79468 0 5.16435C0 6.53401 0.544095 7.84758 1.5126 8.81609C2.4811 9.78459 3.79468 10.3287 5.16435 10.3287H10.3106C10.6437 10.3144 10.9763 10.3677 11.2883 10.4854C11.6003 10.603 11.8852 10.7826 12.126 11.0133C12.3668 11.2439 12.5584 11.5209 12.6892 11.8276C12.8201 12.1343 12.8876 12.4643 12.8876 12.7977C12.8876 13.1312 12.8201 13.4611 12.6892 13.7678C12.5584 14.0745 12.3668 14.3515 12.126 14.5822C11.8852 14.8128 11.6003 14.9924 11.2883 15.1101C10.9763 15.2277 10.6437 15.281 10.3106 15.2667H4.04185L1.32616 17.9824H10.3106C11.6803 17.9824 12.9938 17.4383 13.9623 16.4698C14.9308 15.5013 15.4749 14.1877 15.4749 12.8181C15.4749 11.4484 14.9308 10.1348 13.9623 9.16634C12.9938 8.19783 11.6803 7.65373 10.3106 7.65373Z"
                fill={fill}/>
            <path
                d="M57.4143 0.0175781L47.0857 17.9819H50.2268L57.4143 5.48517L64.5974 17.9819H67.743L57.4143 0.0175781Z"
                fill={fill}/>
            <path
                d="M84.5807 5.85632C84.5807 4.3117 83.9687 2.83002 82.8786 1.73569C81.7885 0.64136 80.3092 0.023565 78.7646 0.0175781H71.1109L72.6588 2.73327H78.7465C79.5796 2.73327 80.3785 3.06422 80.9676 3.6533C81.5567 4.24238 81.8876 5.04134 81.8876 5.87442C81.8876 6.70751 81.5567 7.50647 80.9676 8.09555C80.3785 8.68463 79.5796 9.01558 78.7465 9.01558H76.2752L81.4396 18H84.5807L80.7561 11.3465C81.8802 10.9348 82.8502 10.187 83.5345 9.20477C84.2188 8.22251 84.584 7.05341 84.5807 5.85632Z"
                fill={fill}/>
            <path d="M105.912 0.0181085H95.5834V17.9824H98.2991V2.71569H103.242L105.957 0L105.912 0.0181085Z"
                  fill={fill}/>
            <path
                d="M29.5742 10.3463L19.2456 0.0175781V4.05943L29.5742 14.3881L37.2099 6.7525V17.9819H39.9029V0.0175781L29.5742 10.3463Z"
                fill={fill}/>
            <path
                d="M136.101 0.0225952L127.121 9.00249L129.144 11.0212L136.101 17.9824V13.9405L131.163 9.00249L136.101 4.06445V0.0225952Z"
                fill={fill}/>
            <path
                d="M117.06 0.0225952L124.017 6.9793L126.036 9.00249L117.06 17.9824V13.9405L121.998 9.00249L117.06 4.06445V0.0225952Z"
                fill={fill}/>
        </svg>
      </div>
    )
}

export default LogoTypeSmart